import React from "react"
import Layout from "../components/Layout"
import MainPageHeader from "../components/MainPageHeader/MainPageHeader"
import { BlogPost, SmallBar } from "../components/PageEnd/PageEnd"
import BlogPostContent from "../components/BlogPostContent/BlogPostContent"
import MetaHead from "../components/MetaHead"
import { graphql } from "gatsby"


const BlogPostPage = ({ pageContext, data }) => {

    const { post } = pageContext

  return (
    <Layout>
        <MainPageHeader 
          title={<div className="text-[24px] md:text-[45px] leading-[45px]">{post.Title}</div>} 
          image={"https://content.theinformationlab.co.uk/images/hero_insights_65c4fb858c.png"}
          gatsbyImage={data?.page?.HeroImage?.localFile?.childImageSharp?.gatsbyImageData}
          backLabel={"Insights"}
          backLink={-1}
          accentColour={'blue'}
          small={true}
        />
        <BlogPostContent 
          content={post.Content} 
          meta={{
            publishedAt: post.publishedAt,
            authors: post.Authors,
            createdBy: post.createdBy,
            featureImage: post.FeatureImageUrl || post.FeatureImage?.url,
            excerpt: post.Excerpt,
            postType: post.PostType,
          }} />
        { post?.AlsoInterested ? 
          <BlogPost label="You may also find this interesting..." post={post?.AlsoInterested} />
        : <SmallBar /> }
    </Layout>
  )
}

export default BlogPostPage;

export const Head = ({pageContext}) => <MetaHead
                                  title={`${pageContext?.post?.Title} - The Information Lab`}
                                  description={pageContext?.post?.Excerpt}
                                  image={pageContext?.post?.FeatureImageUrl || pageContext?.post?.FeatureImage?.url}
                                />

export const query = graphql`
query BlogPostQuery {
page: strapiTilWwwPage(slug: {eq: "blog"}) {
  HeroImage {
    url
    localFile {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: WEBP)
      }
    }
  }
  }
}
`
                              